import React from "react";
import { 
  HeroSection,
  CompetitionsSection, 
  AboutSection 
} from "./components";

export default function Home() {
  return (
    <div className="mt-0 pt-0 overflow-hidden">
      <HeroSection />
      <div id="competitions">
        <CompetitionsSection />
      </div>
      <div id="about">
        <AboutSection />
      </div>
      
    </div>
  );
} 